// like !default / !edit / %21viewLogs
import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const globalSettingsIssueTimeTrackingRoute: InvariantJiraRoute = {
	name: 'global-settings-issues-time-tracking',
	path: '/secure/admin/TimeTrackingAdmin([!%]?[\\w]*).jspa',
};
